// https://vuex.vuejs.org/zh-cn/intro.html
// make sure to call Vue.use(Vuex) if using a module system
import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import * as getters from './getters';
// 服务市场
import store from './modules/store';

Vue.use(Vuex);
const state = {
    version: '1.0.1',
    terminal: 'wx', //平台
    host: '', //请求域名
    // cdn: '', //图片cdn域名
    // cdn: 'https://cdn-wx.bdsaas.com',
    cdn: 'https://qrcode.bdsaas.com/wx-app',
    token: '',
    companyId: '', //公司Id
    hasApproveManage: false,
    openId: '',
    companyCode: '', //公司代码
    userInfo: '',
    wxUserInfo: '',
    companyInfo: {},
    credential: {},
    orderPackage: {},
    authSign: {},
    tabbar: false,
    share: false,
    shareInfo: {},
    cart: [], //本地购物车
    area: {}, //微信默认地域
    win: {
        width: '',
        height: ''
    },
    headDOM: {
        title: '数企',
        description: '数企',
        keywords: '数企'
    }
};

/* Configure whether to allow vue-devtools inspection. */
Vue.config.devtools = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        store
    },
    state,
    getters,
    mutations
});
